import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap'
import axios from 'axios'
import STLViewer from '../components/model';
import { STLLoader } from 'three-stdlib';
import { clamp } from 'three/src/math/MathUtils.js';
import { connect } from 'react-redux';
import { refreshJobInDraft } from '../actions/jobDraft';

class ViewModel extends Component {
    state = {
        file: null,
        geometry: null,
        size_x: 0,
        size_y: 0,
        size_z: 0

    }
    openFileSelector = async (e) => {
        this.setState({ file: e.target.files[0] })
    }
    componentDidMount() {
        this.getStuff()
    }
    getStuff = () => {
        this.retrieve();
        this.getDimensions()
    }
    componentDidUpdate(prevProps) {
        if (prevProps?.jobDraft.model !== this.props.jobDraft?.model) {
            this.getStuff()
        }
    }

    fileInputRef = React.createRef();
    clearFileSelector = () => {
        this.setState({ file: null })
        this.fileInputRef.current.value = ""
    }
    getDimensions = () => {
        axios.post('/api/model/get/dimensions', { job: this.props.jobDraft?._id }).then((res) => {
            if (res.data.success) {
                this.setState({ size_x: res.data.x, size_y: res.data.y, size_z: res.data.z })
            } else {
                this.setState({ size_x: 0, size_y: 0, size_z: 0 })
            }
        })
    }
    rotationChanged = (e, axis) => {
        if (axis == "rotation_x") {
            axios.post("/api/jobs/set/rotation", { rotation_x: clamp(e.target.value, 0, 360), rotation_y: this.props.jobDraft.rotation_y, rotation_z: this.props.jobDraft.rotation_z, job: this.props.jobDraft._id }).then(() => this.props.refreshJobInDraft(this.props.jobDraft._id))
        } else if (axis == "rotation_y") {
            axios.post("/api/jobs/set/rotation", { rotation_x: this.props.jobDraft.rotation_x, rotation_y: clamp(e.target.value, 0, 360), rotation_z: this.props.jobDraft.rotation_z, job: this.props.jobDraft._id }).then(() => this.props.refreshJobInDraft(this.props.jobDraft._id))
        } else if (axis == "rotation_z") {
            axios.post("/api/jobs/set/rotation", { rotation_x: this.props.jobDraft.rotation_x, rotation_y: this.props.jobDraft.rotation_y, rotation_z: clamp(e.target.value, 0, 360), job: this.props.jobDraft._id }).then(() => this.props.refreshJobInDraft(this.props.jobDraft._id))
        }
    }

    infillChange = (e) => {
        let val = e.target.value
        if (val > 100) {
            val = 100
        } else if (val < 0) {
            val = 0
        }
        axios.post("/api/jobs/set/infill", { infill: val, job: this.props.jobDraft._id }).then(() => this.props.refreshJobInDraft(this.props.jobDraft._id))
    }
    changeQuality = (selected) => {
        this.setState({ quality: selected }, () => this.props.refreshJobInDraft(this.props.jobDraft._id))
    }
    scaleChanged = (e, type) => {
        if (type == "scale_x") {
            axios.post("/api/jobs/set/scale", { scale_x: e.target.value, scale_y: this.props.jobDraft.scale_y, scale_z: this.props.jobDraft.scale_z, job: this.props.jobDraft._id }).then(() => this.props.refreshJobInDraft(this.props.jobDraft._id))
        } else if (type == "scale_y") {
            axios.post("/api/jobs/set/scale", { scale_x: this.props.jobDraft.scale_x, scale_y: e.target.value, scale_z: this.props.jobDraft.scale_z, job: this.props.jobDraft._id }).then(() => this.props.refreshJobInDraft(this.props.jobDraft._id))
        } else if (type == "scale_z") {
            axios.post("/api/jobs/set/scale", { scale_x: this.props.jobDraft.scale_x, scale_y: this.props.jobDraft.scale_y, scale_z: e.target.value, job: this.props.jobDraft._id }).then(() => this.props.refreshJobInDraft(this.props.jobDraft._id))
        }
    }

    upload = async () => {
        const formData = new FormData()
        formData.append('file', this.state.file)
        formData.append("job", this.props.jobDraft?._id)
        axios.post('/api/model/save', formData).then((res) => {
            this.clearFileSelector();
            this.props.setModelInProgress(res.data.fileName)
            this.getStuff()
            this.props.refreshJobInDraft(this.props.jobDraft._id)

        }).catch(err => { console.log(err) })

    }
    retrieve = async () => {
        try {
            if(!this.props.jobDraft._id){
                return
            }
            let res = await axios.post('/api/model/get/model/by/filename', { job: this.props.jobDraft._id }, { responseType: 'arraybuffer' })
            if (!res.failed) {
                const loader = new STLLoader();
                const geometry = loader.parse(res.data);
                this.setState({ geometry });
            }
        }
        catch (e) {
        }
    }

    brimEnabledChanged = (e) => {
        e.persist()
        axios.post("/api/jobs/set/brim/enabled", { brimEnabled: e.target.checked, job: this.props.jobDraft._id }).then(() => { this.props.refreshJobInDraft(this.props.jobDraft._id) })
    }
    supportsEnabledChanged = (e) => {
        e.persist()
        axios.post("/api/jobs/set/supports/enabled", { supportsEnabled: e.target.checked, job: this.props.jobDraft._id }).then(() => { this.props.refreshJobInDraft(this.props.jobDraft._id) })
    }

    render() {
        let darkmode = this.props.user ? this.props.user.darkmode : true
        const options = [{ type: "Low", id: 0 }, { type: "Medium", id: 1 }, { type: "High", id: 2 }];
        let selected = "Low";

        return (
            <div style={{ width: "100%" }}>
                {/* <input className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} ref={this.fileInputRef} accept=".stl,.gcode" onChange={async (e) => { await this.openFileSelector(e); this.upload() }} type='file'></input> */}
                <div
                    onClick={() => this.fileInputRef.current.click()}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "14px 18px",
                        borderRadius: "12px",
                        border: "1px dashed",
                        borderColor: darkmode ? "#334155" : "#cbd5e1",
                        backgroundColor: darkmode ? "#020617" : "#f8fafc",
                        cursor: "pointer",
                        marginBottom: "16px",
                    }}
                >
                    <input
                        ref={this.fileInputRef}
                        type="file"
                        accept=".stl,.gcode"
                        hidden
                        onChange={async (e) => {
                            await this.openFileSelector(e);
                            this.upload();
                        }}
                    />

                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <span style={{ fontSize: "1.6rem" }}>
                            {this.state.geometry ? "📦" : "🖨️"}
                        </span>
                        <div>
                            <div style={{ fontWeight: 600 }}>
                                {this.state.geometry ? "Model Loaded" : "Upload 3D Model"}
                            </div>
                            <div style={{ fontSize: "0.8rem", opacity: 0.7 }}>
                                {this.state.geometry
                                    ? "Click to replace model"
                                    : "Extensions supported: .STL"}
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            fontSize: "0.85rem",
                            color: this.state.geometry ? "#f59e0b" : "#3b82f6",
                            fontWeight: 500,
                        }}
                    >
                        {this.state.geometry ? "Replace" : "Browse"}
                    </div>
                </div>
                <STLViewer rotation_x={this.props.jobDraft?.rotation_x} rotation_y={this.props.jobDraft?.rotation_y} rotation_z={this.props.jobDraft?.rotation_z} geometry={this.state.geometry} />
                <p>Size: {this.state.size_x}, {this.state.size_y}, {this.state.size_z} mm (x,y,z)</p>
                Infill %: <input value={this.props.jobDraft?.infill} onChange={(e) => this.infillChange(e)} type='number'></input>
                <hr />
                <p>Scale X: <input value={this.props.jobDraft?.scale_x} onChange={(e) => this.scaleChanged(e, "scale_x")} type="number"></input></p>
                <p>Scale Y: <input value={this.props.jobDraft?.scale_y} onChange={(e) => this.scaleChanged(e, "scale_y")} type="number"></input></p>
                <p>Scale Z: <input value={this.props.jobDraft?.scale_z} onChange={(e) => this.scaleChanged(e, "scale_z")} type="number"></input></p>
                <hr />
                {/* <p>Quality</p>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px", justifyContent: "center" }}>
                    {options.map((option) => (
                        <button
                            key={option.id}
                            style={{ backgroundColor: option.id == this.state.quality ? "#3B82F6" : "#35618bff" }}
                            onClick={() => this.changeQuality(option.id)}

                        >
                            {option.type}
                        </button>
                    ))}
                </div> */}
                <p>Rotation X: <input value={this.props.jobDraft?.rotation_x} onChange={(e) => this.rotationChanged(e, "rotation_x")} type="number"></input></p>
                <p>Rotation Y: <input value={this.props.jobDraft?.rotation_y} onChange={(e) => this.rotationChanged(e, "rotation_y")} type="number"></input></p>
                <p>Rotation Z: <input value={this.props.jobDraft?.rotation_z} onChange={(e) => this.rotationChanged(e, "rotation_z")} type="number"></input></p>
                <hr />
                <Row>
                    <Col>
                        <label>Supports Enabled</label>

                    </Col>
                    <Col>
                        <input checked={this.props.jobDraft?.supports} onChange={async (e) => { this.supportsEnabledChanged(e) }} type='checkbox' />

                    </Col>
                </Row>
                {
                    this.props.user && this.props.user.admin && <div>
                        <p>Admin options</p>
                        <Row>
                            <Col>
                                <label>Brim Enabled</label>

                            </Col>
                            <Col>
                                <input checked={this.props.jobDraft?.brim} onChange={async (e) => { this.brimEnabledChanged(e) }} type='checkbox' />

                            </Col>
                        </Row>
                    </div>
                }


            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        jobDraft: state.jobDraft
    }
}
function mapDispatchToProps(dispatch) {
    return {
        refreshJobInDraft: (jobId) => dispatch(refreshJobInDraft(jobId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewModel); 